import styles from './index.scss'
import NoAuthorization from './noAuthorization'
import AgainConfirmAuthorization from './againConfirmAuthorization'
import ReactDOM from 'react-dom'
import  {DpBusinessPopup } from '@/libs/components'

export default function DpBusinessAuthorization(props: any) {
  var dom = document.createElement('div')
  dom.setAttribute('id', 'DpBusinessAuthorization')
  document.body.appendChild(dom)
  ReactDOM.render(<DpBusinessAuthorizationInfo {...props} />, dom)
}

const DpBusinessAuthorizationInfo = (props: any) => {
  const clear = () => {
    if (document.getElementById('DpBusinessAuthorization')) {
      document.body.removeChild(document.getElementById('DpBusinessAuthorization'))
    }
  }
  return (
    <DpBusinessPopup
      visible={true}
      title={'手机号授权'}
      onClose={clear}
      headerStyle={{ borderBottomWidth: 0 }}
      titleStyle={{
        color: 'var(--primary-text-color, #222222)',
      }}
      popupBodyStyles={{
        ...props?.customStyles,
        background: `var(--page-bg-color, #f5f6f8)`,
        minHeight: '30vh'
      }}
      containerStyles={{
        background: `var(--page-bg-color, #f5f6f8)`,
        padding: '12px 20px 20px'
      }}
      headerClassName={styles['dp-dialogAuthorization-header']}
    >
      <div className={styles['dp-dialogAuthorization']}>
        {(props?.data?.authorization || props?.data?.authorizationPhone) ? 
          <AgainConfirmAuthorization {...props} onConfirm={(values: any) => props?.onConfirm?.(clear, values)} />
          :
          <NoAuthorization {...props} onConfirm={(values: any) => props?.onConfirm?.(clear, values)} />
        }
      </div>
    </DpBusinessPopup>
  )
}